import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_premium-tire-hub-1/artifacts/jmbt2xv5_2026-03-07%2012.49.35.jpg";

export const Hero = ({ settings }) => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Use settings from CMS or defaults
  const heroTitle = settings?.hero_title || "PERRY D TIRES:";
  const heroSubtitle = settings?.hero_subtitle || "Professional Tire Service 2026";
  const heroTagline = settings?.hero_tagline || "New and Used Tires. Quality and Speed.";
  const heroPromo = settings?.hero_promo || "FREE TIRE CHANGE & BALANCING";

  return (
    <section 
      id="hero" 
      className="relative min-h-screen w-full overflow-hidden"
      data-testid="hero-section"
    >
      {/* Full-bleed Background Image */}
      <div 
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: `url(${HERO_IMAGE})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center right',
          backgroundRepeat: 'no-repeat',
        }}
        data-testid="hero-image"
      />
      
      {/* Mobile: stronger gradient covering more area */}
      <div 
        className="absolute inset-0 lg:hidden"
        style={{
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.6) 40%, rgba(0,0,0,0.4) 70%, rgba(0,0,0,0.7) 100%)',
        }}
      />
      
      {/* Desktop: gradient on left side */}
      <div 
        className="absolute inset-0 hidden lg:block"
        style={{
          background: 'linear-gradient(to right, #000000 0%, #000000 20%, rgba(0,0,0,0.9) 30%, rgba(0,0,0,0.6) 45%, rgba(0,0,0,0.2) 55%, transparent 65%)',
        }}
      />
      
      {/* Top gradient for navbar */}
      <div className="absolute top-0 left-0 right-0 h-20 lg:h-28 bg-gradient-to-b from-black/70 to-transparent" />
      
      {/* Bottom gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-[#050505] to-transparent" />

      {/* Content Container */}
      <div className="relative z-10 min-h-screen flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-20 lg:py-0">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="w-full lg:max-w-xl space-y-4 lg:space-y-6 text-center lg:text-left"
          >
            <h1 
              className="font-heading text-3xl sm:text-4xl lg:text-6xl xl:text-7xl text-white leading-tight"
              data-testid="hero-title"
            >
              {heroTitle}
              <br />
              <span className="text-[#FF2E2E]">{heroSubtitle.split(' ').slice(0, 2).join(' ')}</span>
              <br />
              {heroSubtitle.split(' ').slice(2).join(' ')}
            </h1>
            
            <p 
              className="font-body text-white/90 text-base sm:text-lg lg:text-xl max-w-md mx-auto lg:mx-0"
              data-testid="hero-subtitle"
            >
              {heroTagline}
            </p>

            {/* Free Service Banner */}
            <div className="inline-block glass border border-[#FF2E2E]/50 px-4 py-2 lg:px-6 lg:py-3">
              <p className="font-heading text-[#FF2E2E] text-sm lg:text-lg tracking-wider">
                {heroPromo}
              </p>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="pt-2 lg:pt-4"
            >
              <Button 
                onClick={() => scrollToSection('#contact')}
                className="bg-[#FF2E2E] hover:bg-[#D61E1E] text-white font-heading text-sm lg:text-base tracking-wider px-6 lg:px-8 py-5 lg:py-6 rounded-none border border-[#FF2E2E] transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,46,46,0.5)]"
                data-testid="hero-contact-btn"
              >
                Book Your Service
              </Button>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
